import { render, staticRenderFns } from "./miniprogram-selector.vue?vue&type=template&id=55d39913&"
import script from "./miniprogram-selector.vue?vue&type=script&lang=js&"
export * from "./miniprogram-selector.vue?vue&type=script&lang=js&"
import style0 from "./miniprogram-selector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports